<template>
  <div id="app">
    <h1><img src="@/assets/CSI_Logo.png" height="50px">  <a href="/">Database Current State Investigation (CSI)</a></h1>

    <div v-if="!(signedIn || signedIn==undefined)">

     
      DBCSI is a tool to help you and AWS collaboratively look at the performance metrics of your current databases.<br/>
      <div class="container-fluid">
        <b-button
                v-b-toggle.showAbout
                size="sm"
                variant="link"
              ><b>Learn More About DBCSI</b></b-button>
              <b-collapse id="showAbout">
                <about2/>
                </b-collapse>
                <small><br/>Looking to download the <a href="/aws_awr_miner.sql" target="_blank">AWR-based data collection script</a> (requires Diagnostic Pack) or the <a href="/aws_statspack_miner.sql" target="_blank">STATSPACK-based data collection script</a> ?</small>
      </div>
      <!--<img src="@/assets/CSI_screenshot.png" height="200px">-->
      <br/>



      <!--<div class="container" style="margin-bottom: 2cm;">-->
        <!--<b-button-->
        <!--        v-b-toggle.showCalc-->
        <!--        size="sm"-->
        <!--        variant="link"-->
        <!--      >EC2 and RDS Estimator</b-button>-->
        <!--      <b-collapse id="showCalc">-->
        <!--        <calculator2/>-->
        <!--        </b-collapse>-->
      <!--</div>-->
      

          <b-card border-variant="primary"
                header-bg-variant="primary"
                header-text-variant="white" bg-variant="light" header="Please Sign In or Create an Account to use DB CSI (see below)...">
            <!-- Midway button hidden from users until ready. Flip showMidwayButton to true
                 to expose to everyone, or append ?midway=1 to the URL to reach it for testing. -->
            <template v-if="showMidwayButton || $route.query.midway === '1'">
              <b-button variant="primary" block class="mb-2" @click="signInWithMidway">
                AWS Employees: Sign in with Midway
              </b-button>
              <div class="mb-3"><small>External users: create an account or sign in below.</small></div>
            </template>
            <amplify-authenticator>
              <amplify-sign-up
                header-text="Create a new DBCSI account"
                slot="sign-up"
                :formFields.prop="formFields"
              ></amplify-sign-up>
            </amplify-authenticator>
          </b-card>  
        <br/>
      <small>
          <br/>DBCSI is experimental, not officially supported by AWS, and is provided as-is. Please see <a href="https://aws.amazon.com/service-terms/" target="_blank">AWS Service Terms</a> Sec. 2.
          <br/>DBCSI is provided under the <a href="https://aws.amazon.com/legal/aws-ip-license-terms/" target="_blank">AWS Intellectual Property License</a>.
          <br/><a href="/LICENSE-THIRD-PARTY.txt" target="_blank">OpenSource Attribution Notice</a><br/>
        </small>
        <br/>




    </div>
    
    
    <div v-if="signedIn">
<!-- <div v-if="!signedIn"> -->
      <div >
        <small>Welcome {{ canonicalUser }}
          <br/>The purpose of this tool is to provide a sizing estimate and ball park pricing. This is not a substitute for performance testing.
          <br/>DBCSI is experimental, not officially supported by AWS, and is provided as-is. Please see <a href="https://aws.amazon.com/service-terms/" target="_blank">AWS Service Terms</a> Sec. 2.
          <br/>DBCSI is provided under the <a href="https://aws.amazon.com/legal/aws-ip-license-terms/" target="_blank">AWS Intellectual Property License</a>.
          <br/>Looking to download the data collection scripts ? Go <router-link :to="{ name: 'Add'}">here</router-link>
        </small>

      </div>


      <div class="container-fluid" style="margin-bottom: 2cm;">
        <router-view :user="canonicalUser"></router-view>
      </div>

      
      <div>
        <router-link :to="{ name: 'About'}">About Database CSI</router-link>   &nbsp;&nbsp;
        <a href="/LICENSE-THIRD-PARTY.txt" target="_blank">OpenSource Attribution Notice</a><br/>
        <a href="https://www.youtube.com/watch?v=CDW2Vb3gOe8" target="_blank">Introductory Video</a> 
          &nbsp;&nbsp;  <a href="https://apg-library.amazonaws.com/content/cac5ee4e-1530-4b6c-9b94-ef8be74a9ab1" target="_blank">Partner Guide</a> <br/>
        Suggestions or feedback for Database CSI? <a href="mailto:dbayard@amazon.com">Email us</a> or use the internal #dbcsi slack channel.
      </div>  
      <br/>
      <amplify-sign-out class="signout"></amplify-sign-out>



    
    </div>
  </div>
</template>

<script>

import { Auth } from "aws-amplify";
import About2 from '@/components/About'
// import Calculator2 from '@/components/Calculator'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

export default {
  name: "app",
  components: {
    about2: About2
    // ,calculator2: Calculator2
  },

  async created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      if (this.authState === "signedin") {
        // console.log("Auth2",authState, authData);
        this.signedIn = true;
      } else {
        // console.log("Auth2a",authState, authData);
        this.signedIn = false;
        // The sign-in UI (re)mounts when not signed in; re-hide the Hosted UI button.
        this.$nextTick(() => this.hideHostedUiButton());
      }
      this.user = authData;
    });
    try {
      this.user = await Auth.currentAuthenticatedUser();
      
      this.signedIn = true;
      // console.log("Auth1", this.signedIn);
    } catch (err) {
      // console.log("Auth1f", this.signedIn);
      this.signedIn = false; 
    }
    
  },
  beforeDestroy() {
    this.unsubscribeAuth();
  },
  methods: {
    signInWithMidway() {
      // Redirect to the Cognito Hosted UI for the Amazon Federate (Midway) IdP.
      // Provider name must match override.ts PROVIDER_NAME ('AmazonFederate').
      Auth.federatedSignIn({ provider: 'AmazonFederate' });
    },
    hideHostedUiButton(attempt = 0) {
      // Amplify renders a built-in "Sign in with AWS" Hosted UI button
      // (<amplify-federated-buttons>) whenever oauth is configured. It lives inside
      // nested shadow roots, so CSS can't reach it -- find the host across shadow
      // roots and hide it. Retries while the web components hydrate.
      const deepFind = (root, sel) => {
        if (!root) return null;
        const hit = root.querySelector && root.querySelector(sel);
        if (hit) return hit;
        const nodes = root.querySelectorAll ? root.querySelectorAll("*") : [];
        for (const n of nodes) {
          if (n.shadowRoot) {
            const f = deepFind(n.shadowRoot, sel);
            if (f) return f;
          }
        }
        return null;
      };
      const el = deepFind(document, "amplify-federated-buttons");
      if (el) {
        el.style.display = "none";
      } else if (attempt < 20) {
        setTimeout(() => this.hideHostedUiButton(attempt + 1), 150);
      }
    }
  },
  mounted() {
    this.hideHostedUiButton();
  },
  computed: {
    // Canonical DBCSI user id shown in the UI and passed to routes. Mirrors the
    // backend resolver (toCanonicalPersonId): federated users arrive as
    // "AmazonFederate_<alias>" and map to the reserved id "amzn~<alias>".
    canonicalUser() {
      const u = (this.user && this.user.username) ? this.user.username : '';
      const prefix = 'AmazonFederate_';
      return u.startsWith(prefix) ? 'amzn~' + u.slice(prefix.length).toLowerCase() : u;
    }
  },
  data() {
    return {
      signedIn: undefined,
      showMidwayButton: false, // set true (or append ?midway=1) to expose the Midway sign-in button
      user: '',
      authState: undefined,
      unsubscribeAuth: undefined,
      formFields: [
            { type: "username" },
            { type: "password" },
            { type: "email", required: true, label: "Business Email Address *", placeholder: "Enter your business email address" }
        ]
    };
  }
};
</script>

<style>
/* Amplify auto-renders a built-in Hosted UI ("Sign In with AWS") button whenever an
   oauth config is present. We don't want it: internal users use our explicit
   "Sign in with Midway" button, external users use the username/password form.
   Hide that button and its "or" divider (ui-components render in light DOM). */
/* NOTE: Amplify's built-in "Sign in with AWS" Hosted UI button renders inside nested
   shadow roots (amplify-authenticator > amplify-sign-in > amplify-federated-buttons),
   so it CANNOT be hidden with CSS. It is hidden via JS in hideHostedUiButton().
   Internal users use our "Sign in with Midway" button; external users use the form. */

body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}

.signout {
  background-color: #ededed;
  margin: 0;
  padding: 11px 0px 1px;
}
.Chart {
  /* background: #212733; */
  border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  margin:  25px 0;
}

.Chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color:  rgba(255, 0,0, 0.5);
  border-bottom: 1px solid #323d54;
}
</style>
